var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "card-wrapper d-flex flex-column position-relative h-100",
      class: { popular: _vm.popular, dark: _vm.dark },
    },
    [
      _vm.popular ? _c("popular-tag") : _vm._e(),
      _c("h2", { staticClass: "plan-title font-outfit-semi-bold" }, [
        _vm._v(" " + _vm._s(_vm.title) + " "),
      ]),
      _c("p", { staticClass: "plan-description flex-auto mt-0" }, [
        _vm._v(" " + _vm._s(_vm.description) + " "),
      ]),
      _c(
        "div",
        { staticClass: "description" },
        [
          _c("plan-card-price", {
            attrs: {
              period: _vm.period,
              price: _vm.price,
              "monthly-price": _vm.monthlyPrice,
              currency: _vm.currencySymbol,
              loading: _vm.loading,
              dark: _vm.dark,
            },
          }),
          _c(
            "p",
            { staticClass: "price-no-ideas" },
            [
              _vm._v(" " + _vm._s(_vm.$t("pages.pricing.numberOf")) + " "),
              _c(
                "ib-tooltip",
                {
                  attrs: {
                    content: _vm.$t("pages.pricing.numberOfIdeas"),
                    dark: !_vm.dark,
                  },
                },
                [
                  _c("span", { staticClass: "text-lowercase" }, [
                    _vm._v(_vm._s(_vm.$tc("idea", 2))),
                  ]),
                ]
              ),
              _vm._v(" & "),
              _c(
                "ib-tooltip",
                {
                  attrs: {
                    content: _vm.$t("pages.pricing.numberOfCollaborators"),
                    dark: !_vm.dark,
                  },
                },
                [
                  _c("span", { staticClass: "text-lowercase" }, [
                    _vm._v(_vm._s(_vm.$tc("collaborator", 2))),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "actions" },
        [
          _c("input-number", {
            staticClass: "input-number",
            attrs: { options: _vm.options, disabled: _vm.loading },
            model: {
              value: _vm.content,
              callback: function ($$v) {
                _vm.content = $$v
              },
              expression: "content",
            },
          }),
          _c(
            "ib-button",
            {
              staticClass: "cta-button w-100",
              attrs: {
                variant: _vm.dark ? "yellow" : "blue",
                size: "sm",
                disabled: !_vm.price || _vm.loading,
                loading: _vm.buttonLoading,
              },
              on: { click: _vm.onChoosePlan },
            },
            [_vm._v(" " + _vm._s(_vm.$t("buyNow")) + " ")]
          ),
        ],
        1
      ),
      _c("div", { staticClass: "features text-left" }, [
        _c("h5", { staticClass: "title font-outfit-medium" }, [
          _vm._v(" " + _vm._s(_vm.$t("pages.pricing.featuresIncluded")) + " "),
        ]),
        _c(
          "ul",
          [
            _c("plan-card-ai-requests", {
              attrs: {
                "num-of-requests": _vm.plan ? _vm.plan.aiRequests : null,
                dark: _vm.dark,
              },
            }),
            _vm._l(_vm.features, function (feature) {
              return _c(
                "li",
                {
                  key: feature.id,
                  staticClass: "font-outfit-light",
                  class: {
                    active:
                      !_vm.disabledFeatures ||
                      !_vm.disabledFeatures.includes(feature.id),
                  },
                },
                [
                  _c(
                    "ib-tooltip",
                    {
                      attrs: {
                        content: feature.hint,
                        disabled:
                          _vm.disabledFeatures &&
                          _vm.disabledFeatures.includes(feature.id),
                        dark: !_vm.dark,
                      },
                    },
                    [_c("span", [_vm._v(_vm._s(feature.text))])]
                  ),
                ],
                1
              )
            }),
          ],
          2
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }